import React from "react"
import Label from "@kit/design/label"
import PixelSlider from "@kit/design/pixel-slider"
import { ColorInput } from "@kit/design/color-picker"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { Padding } from "../../components/padding"
import { Margin } from "app/regions/blocks/section/utils/margin"
import { Expander } from "app/regions/blocks/shared/expander"
import { BackgroundColor } from "../../components/background-color"
import { BorderSettings } from "../../components/border-settings"
import { FontSettings } from "../../../header/utils/font-settings"
import { BlocksImageUploader } from "app/regions/blocks/shared/blocks-image-uploader"
import { GAP_IF_UNDEFINED } from "./constants"
import { useSavedColors } from "hooks/use-saved-colors"

export function ArticleCardsSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const savedColors = useSavedColors()
  return (
    <>
      <div className="mb-4">
        <BlocksImageUploader
          className="h-40"
          label="Left image"
          name="image"
          image={properties.left_image}
          alt={properties.left_alt}
          update={file =>
            update({
              left_image: file.image || properties.left_image,
              left_alt: file.alt
            })
          }
          remove={() => update({ left_image: "", left_alt: "" })}
        />
      </div>

      <div className="mb-4">
        <BlocksImageUploader
          className="h-40"
          label="Right image"
          name="right_image"
          image={properties.right_image}
          alt={properties.right_alt}
          update={file =>
            update({
              right_image: file.image || properties.right_image,
              right_alt: file.alt
            })
          }
          remove={() => update({ right_image: "", right_alt: "" })}
        />
      </div>

      <Expander label="Colors">
        <BackgroundColor properties={properties} update={update} />

        <div>
          <Label htmlFor="headingColor">Heading</Label>
          <ColorInput
            id="headingColor"
            name="headingColor"
            onChange={color => update({ headingColor: color.hex })}
            value={properties.headingColor}
            savedColors={savedColors}
          />
        </div>

        <div>
          <Label htmlFor="textColor">Text</Label>
          <ColorInput
            id="textColor"
            name="textColor"
            onChange={color => update({ textColor: color.hex })}
            value={properties.textColor}
            savedColors={savedColors}
          />
        </div>
      </Expander>

      <Expander label="Spacing">
        <div className="mb-4">
          <PixelSlider
            label="Gap"
            name="gap"
            value={
              properties.gap === undefined ? GAP_IF_UNDEFINED : properties.gap
            }
            onChange={e => update({ gap: e })}
            min={0}
            max={60}
          />
        </div>

        <div className="mb-4">
          <Padding properties={properties} update={update} />
        </div>

        <div className="mb-4">
          <Margin properties={properties} update={update} />
        </div>
      </Expander>

      <Expander label="Fonts">
        <FontSettings
          label="Heading font"
          fontFamilySetting="headingFontFamily"
          fontWeightSetting="headingFontWeight"
          properties={properties}
          update={update}
        />

        <FontSettings
          label="Paragraph font"
          fontFamilySetting="textFontFamily"
          fontWeightSetting="textFontWeight"
          properties={properties}
          update={update}
        />
      </Expander>

      <BorderSettings properties={properties} update={update} />
    </>
  )
}
